import { Injectable } from '@angular/core';
import { ServiceLibrary } from '@common_libraries/helpers/ServiceLibrary';
import {Observable, Subject,  BehaviorSubject } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';
import {shareReplay} from 'rxjs/operators';
@Injectable({providedIn: 'root'})
export class FileManagementService {

  constructor(private servLib: ServiceLibrary) { }

  PrepareUpload(assembledFileName: string, TotalChunks: number, TotalFileSize: number, UniqueFileIdentifierKey: string) {
    const parameters: Dictionary = new Dictionary([]);
    parameters.addOrUpdate('AssembledFileName', assembledFileName);
    parameters.addOrUpdate('TotalChunks', TotalChunks);
    parameters.addOrUpdate('TotalFileSize', TotalFileSize);
    parameters.addOrUpdate('UniqueIdentifier', UniqueFileIdentifierKey);

    return this.servLib.HttpPost('/v1/api/File/PrepareUpload', ServiceLibrary.ContentType.JSON, parameters);
  }

  LogFileUploadError(Message: string, ExtraDetails: string) {
    const parameters: Dictionary = new Dictionary([]);
    parameters.addOrUpdate('Message', Message);
    parameters.addOrUpdate('ExtraDetails', ExtraDetails);

    return this.servLib.HttpPost('/v1/api/File/LogFileUploadError', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetFileUploadTokenProcessingStatuses(TokenList: string[]) {
    const parameters: Dictionary = new Dictionary([]);
    parameters.addOrUpdate('TokenList', TokenList);
    if(TokenList.length === 0){
      const subj = new BehaviorSubject<any>(false);

      return subj;
    }else {
      return this.servLib.HttpPostPolling('/v1/api/File/GetFileUploadTokenProcessingStatuses', ServiceLibrary.ContentType.JSON, parameters);
    }
  }


}
